export default "__VITE_ASSET__DHR2rDe7__"